import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import PagePreviewQuery from '../../components/PagePreviewQuery.gql';
import Image from '@jetshop/ui/Image/Image';
import { styled, css } from 'linaria/react';
import { Above } from '@jetshop/ui/Breakpoints';
import { theme } from '../Theme';
import { Link } from 'react-router-dom';

const PDPJournalWrapper = styled('div')`
  display: flex;
  flex-direction: ${props => (props.direction === 'row' ? 'row' : 'column')};
  width: 100%;
  background-color: ${theme.colors.newPrimary};
  margin-bottom: ${props => (props.direction === 'row' ? '20px' : '0')};

  ${theme.below.xl} {
    flex-direction: column;
  }
`;

const PostImageWrapper = styled('div')`
  width: ${props => (props.direction === 'row' ? '50%' : '100%')};
  ${theme.below.xl} {
    width: 100%;
  }
`;

const PDPJournalContentWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 30px;
  background-color: ${theme.colors.newPrimary};
  height: 100%;
  width: ${props => (props.direction === 'row' ? '50%' : '100%')};
  justify-content: ${props =>
    props.direction === 'row' ? 'flex-end' : 'space-between'};

  .post-title {
    color: #000;
    font-family: 'Silk Serif';
    font-size: 35px;
    font-style: normal;
    font-weight: 300;
    line-height: 37px;
    margin-bottom: 20px;
  }

  .post-ingress {
    color: #000;
    font-family: 'Brandon Grotesque';
    font-size: 16px;
    font-style: normal;
    font-weight: 330;
    line-height: 24px;
    margin-bottom: 30px;
    flex-grow: ${props => (props.direction === 'row' ? 'none' : '1')};
  }

  ${theme.below.xl} {
    width: 100%;
  }
`;

const PDPJournalLink = styled(Link)`
  color: #000;
  text-align: center;
  font-family: 'Brandon Grotesque';
  font-size: 14px;
  font-style: normal;
  font-weight: 390;
  line-height: normal;
  letter-spacing: 0.42px;

  text-decoration: none;
  padding: 10px 20px;
  background-color: #fff;
  width: 144px;
  text-align: center;
`;

export const PDPJournalPost = ({ postId, direction }) => {
  const { data } = useQuery(PagePreviewQuery, {
    variables: {
      id: postId
    },
    errorPolicy: 'ignore'
  });

  const postImage = data?.page?.data?.items?.find(
    item => item.type === 'JournalHero'
  );
  const postTitle = data?.page?.name;

  const desktopImageUrl = postImage?.properties?.find(
    prop => prop.name === 'desktopImageUrl'
  )?.value?.value;

  const mobileImageUrl = postImage?.properties?.find(
    prop => prop.name === 'mobileImageUrl'
  )?.value?.value;

  const ingress = postImage?.children
    ?.find(child => child.type === 'ingress')
    ?.properties?.find(prop => prop.name === 'htmlcontent')?.value?.value;
  const postLink = data?.page?.primaryRoute?.path;

  const imageSizes = [1 / 4, 1 / 2, 1, 1, 1];

  return (
    <PDPJournalWrapper direction={direction}>
      <PostImageWrapper direction={direction}>
        <Above breakpoint="xl">
          {matches => (
            <Image
              cover
              sizes={imageSizes}
              aspect={
                matches ? (direction === 'row' ? '1:1' : '390:340') : '390:340'
              }
              src={matches ? desktopImageUrl : mobileImageUrl}
            />
          )}
        </Above>
      </PostImageWrapper>
      <PDPJournalContentWrapper direction={direction}>
        <div className="post-title">{postTitle}</div>
        <div
          className="post-ingress"
          dangerouslySetInnerHTML={{ __html: ingress }}
        />
        <PDPJournalLink to={postLink}>Les mer</PDPJournalLink>
      </PDPJournalContentWrapper>
    </PDPJournalWrapper>
  );
};
